import React from 'react';
import { Link } from 'react-router-dom';
import { SvgIcon } from 'core/icons';
import { BYO_CLOSE, dispatchCustomEvent } from '../../../utils/customMessage';
import { Translate } from '../../../../core/translate';
import { combineClassNames } from '../../../../core/css';

const OptionLink = ({ link, label, analyticsKey, analyticsKey2, svg }) => {
  const stopEventPropagation = (event) => {
    event.stopPropagation();
    dispatchCustomEvent(BYO_CLOSE);
  };
  return (
    <span
      className="stat-button-link option-links__option-container"
      onClick={stopEventPropagation}
      data-dtm={analyticsKey}
      data-dtm2={analyticsKey2}>
      <Link to={link} className="option-link option-link--details">
        <SvgIcon name={svg} className="option-link__svg" />
        <span className="option-links__label">
          <Translate value={label} />
        </span>
      </Link>
    </span>
  );
};

const OptionLinks = ({ options, className }) => {
  const links = options.bodyLinks.map(
    ({ link, label, svg, analyticsKey, analyticsKey2 }) => (
      <OptionLink
        key={label}
        link={link}
        label={label}
        analyticsKey={analyticsKey}
        analyticsKey2={analyticsKey2}
        svg={svg}
        className={className}
      />
    )
  );
  return (
    <div className={combineClassNames('option-links-container', className)}>
      {links}
    </div>
  );
};

export default OptionLinks;
